function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var CustomPush = /*#__PURE__*/function () {
  function CustomPush() {
    _classCallCheck(this, CustomPush);
  }
  return _createClass(CustomPush, [{
    key: "show",
    value: function show(options) {
      var _this = this;
      var timeNow = new Date().toLocaleTimeString();
      this.title = typeof options.title !== "undefined" ? options.title : '';
      this.text = typeof options.text !== 'undefined' ? options.text : '';
      this.img = typeof options.img !== 'undefined' ? options.img : '/img/logos/logo.svg';
      this.btmClass = typeof options.btmClass !== 'undefined' ? options.btmClass : "";
      this.btmText = typeof options.btmText !== 'undefined' ? options.btmText : "Ok";
      this.btm = options.btm === true ? "<div class=\"push__item__btm hover__o ".concat(this.btmClass, "\">").concat(this.btmText, "</div>") : '';
      if (document.querySelector('.push__item')) document.querySelector('.push__item').remove();
      var push = document.createElement("div");
      push.classList.add("push__item");
      // push.draggable = true
      document.body.appendChild(push);
      push.innerHTML += "<div class=\"push__item__head\">\n    <img draggable=\"false\" class=\"push__item__icon\" src=\"".concat(this.img, "\"/>\n    <div class=\"push__item__logoname\">Fixdevice.pro</div>\n    <div class=\"push__item__time\">").concat(timeNow, "</div>\n    <div class=\"push__item__exit\"></div>\n    </div>\n    <div class=\"push__item__body\">\n    <p>").concat(this.title, "</p>\n    <p>").concat(this.text, "</p>\n    ").concat(this.btm, "\n    </div>\n    </div>");
      var tl = gsap.timeline();

      // if (window.innerWidth > 800) {
      //   tl.fromTo(push, { x: 500,opacity: 0 }, { x: 0, opacity: 1, ease: "power3.out" , duration: .2 });
      // }
      // else {
      //   tl.fromTo(push, { y: -100, opacity: 1 }, { y: 0, opacity: 1, ease: "power3.out" , duration: .2 });
      //   console.log(2, window.innerWidth);
      // }

      setTimeout(function () {
        push.classList.add('active');
      }, 0);
      document.querySelectorAll(".push__item__exit").forEach(function (el) {
        return el.onclick = function (e) {
          return _this.hide(push);
        };
      });
      var firstPixel = null;
      push.addEventListener('touchmove', function (event) {
        if (!firstPixel) firstPixel = event.changedTouches[0].clientY;
        if (event.changedTouches[0].clientY < firstPixel) {
          tl.to(push, {
            duration: .3,
            y: "-300px",
            onComplete: function onComplete() {
              push.remove();
            }
          });
        }
      });
      soundPush('/sound/ps5/ps5-popup1.mp3');
      setTimeout(function () {
        return _this.hide(push);
      }, 3000);
    }
  }, {
    key: "hide",
    value: function hide(elem) {
      if (!elem) elem = document.querySelector('.push__item');
      tl.to(elem, {
        duration: .2,
        opacity: 0,
        ease: "power3.out",
        onComplete: function onComplete() {
          elem.remove();
        }
      });
      // elem.classList.remove('active')
      // setTimeout(() => {
      //   elem.remove()
      // }, 200);
    }
  }]);
}();